import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const UploadFileIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue9fc'}</MuiIcon>
    );
}
